<template>
  <b-container fluid class="incidences-in-warehouse">
    <h1 v-translate="{countdown}">Incidences In Warehouse <small>(Autorefresh in %{countdown}s)</small></h1>
    <b-row v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0">
      <b-col>
        <label for="filter-warehouse" v-translate>Show List</label>
        <b-form-radio-group v-model="statusFilter" :options="['INCIDENCE', 'TOBERETURNED']"></b-form-radio-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label for="filter-warehouse" v-translate>Select Your Warehouse</label>
          <b-form-select v-model="filterWarehouse" :options="warehousesSelect">
            <template slot="first">
              <option :value="null" v-translate>None</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0">
          <label for="filter-warehouse" v-translate>Scan or filter by ID</label>
          <b-form-input v-model="filterId" type="search" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-alert variant="warning" class="my-3" show v-else>
      <h4 class="my-0" v-translate>You need to set a Country and the Country must have warehouses set.</h4>
    </b-alert>
    <b-row>
      <b-col class="my-3">
        <span v-translate="{totalCount}">Total Count: <strong>%{totalCount}</strong></span>
        <b-button size="sm" variant="primary" @click.prevent="copyToClipboard(shippings.map(x => { return x.id }).join('\n'), 'IDs')" class="py-1 px-2 ml-2" :disabled="shippings.length === 0" v-translate>
          Copy IDs
        </b-button>
      </b-col>
    </b-row>
    <b-table
      ref="shippingsTable"
      stacked="md"
      foot-clone
      :items="fetchIncidencesInWarehouse"
      :fields="fields"
      id="my-table"
      show-empty
      :empty-text="$gettext('There is nothing to show')"
      :total-rows="totalRows"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong v-translate>Loading...</strong>
      </div>
      <template v-slot:cell(id)="data">
        <a :href="'/edit/shippings/' + data.value">{{data.value | uuid }}</a> <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
      </template>
      <template v-slot:cell(company_id)="row">
        <div v-if="row.item.company_id">
          <b-badge variant="dark" v-translate>Company</b-badge><br>
          <a :href="'/edit/companies/' + row.item.company_id" target="_blank">#{{row.item.company_id}}</a> {{row.item.company.name}}
        </div>
        <div v-else>
          <b-badge variant="secondary" v-translate>Particular</b-badge><br>
          <a :href="'/edit/users/' + row.item.user_id" target="_blank">#{{row.item.user_id}}</a> {{row.item.user.name}}
        </div>
      </template>
      <template v-slot:cell(last_courier)="row">
        <user-card :user='row.item.last_courier' v-if="row.item.last_courier" :profile-picture="false" :with-titles="false" :vehicle-types-prop="vehicleTypes" />
      </template>
      <template v-slot:cell(address_to)="row">
        <span v-if="(!row.item.fields_revision || row.item.fields_revision === false) || !row.item.fields_revision_data.to || typeof row.item.fields_revision_data.to === 'object'">
          <span
            class="shipping-address-listings"
            :class="row.item.fields_revision_data &&
              row.item.fields_revision_data.to &&
              typeof row.item.fields_revision_data.to === 'object' ? 'text-warning' : ''"
            :title="row.item.address_to ? row.item.address_to.formatted_address : $gettext('ERROR IN SHIPPING ADDRESS')"><font-awesome-icon v-if="row.item.fields_revision_data &&
              row.item.fields_revision_data.to &&
              typeof row.item.fields_revision_data.to === 'object'" icon="exclamation-triangle" size="1x" /> {{row.item.address_to ? row.item.address_to.formatted_address : $gettext('ERROR IN SHIPPING ADDRESS')}}</span>
        </span>
        <span v-if="row.item.fields_revision_data !== null && typeof row.item.fields_revision_data.to === 'string'">
          <span class="shipping-address-listings text-danger" :title="row.item.fields_revision_data.to"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{row.item.fields_revision_data.to}}</span>
        </span>
        <div v-if="row.item.fields_revision_data && row.item.fields_revision_data.to">
          <b-button pill size="sm" @click.prevent="shipping = row.item" v-b-modal.modalFixAddressTo style="clear: both;padding: 0.1rem 1rem;" v-translate>Review Address</b-button>
        </div>
        <h6>{{row.item.to_contact}}</h6>
      </template>
      <template v-slot:cell(last_incidence)="data">
        <strong>{{data.value.details.reason}}</strong><br>
        {{moment.utc(data.value.created_at).tz($tz).format('L LT')}}
      </template>
      <template v-slot:cell(incidences_count)="data">
        <div v-if="data.item.maxDeliveryIncidencesSetting" :class="data.item.maxDeliveryIncidencesSetting > data.item.currentDeliveryIncidences ? 'text-success' : 'text-danger font-weight-bold'" v-translate="{maxDeliveryIncidencesSetting: data.item.maxDeliveryIncidencesSetting, currentDeliveryIncidences: data.item.currentDeliveryIncidences}">
          On Delivery: %{currentDeliveryIncidences}/%{maxDeliveryIncidencesSetting}
        </div>
        <div v-for="(item, index) in filterIncidenceTypes(data.item.status_history)" :key="index">
          {{ item }} ({{countIncidenceTypes(data.item.status_history, item)}})
        </div>
      </template>
      <template v-slot:cell(warehouse_in_date)="data">
        {{data.value ? moment.utc(data.value).tz($tz).format('L') : ''}}<br>
        {{data.value ? moment.utc(data.value).tz($tz).format('LT') : ''}}
      </template>
      <template v-slot:cell(need_correction)="row">
        <font-awesome-icon icon="exclamation-triangle" class="text-warning" size="2x" v-if="row.item.need_correction && !row.item.is_corrected" />
        <font-awesome-icon icon="check" class="text-success" size="2x" v-else-if="row.item.need_correction && row.item.is_corrected" />
      </template>
      <template v-slot:cell(is_corrected)="row">
        <font-awesome-icon :icon="['far', 'times-circle']" class="text-danger" size="2x" v-if="row.item.need_correction && !row.item.is_corrected" />
        <font-awesome-icon icon="check" class="text-success" size="2x" v-else-if="row.item.need_correction && row.item.is_corrected" />
      </template>
      <template v-slot:cell(actions)="row">
        <div v-if="row.item.status === 'INCIDENCE'">
          <b-button block size="sm" @click.prevent="setAsReady(row.item)" style="padding: .05rem .65rem" :disabled="row.item.need_correction && !row.item.is_corrected" v-translate>
            Set As READY
          </b-button>
          <b-button block size="sm" variant="warning" @click.prevent="editingShipping = row.item.id" style="padding: .05rem .65rem" v-b-modal.modalTobereturnedReason v-translate>
            Set As TOBERETURNED
          </b-button>
        </div>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" v-if="totalRows > perPage" class="my-0" />

    <b-modal id="modalTobereturnedReason" ref="modalTobereturnedReason" :hide-footer="true" @hide="editingShipping = null">
      <div slot="modal-title" v-translate>TOBERETURNED Reason</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-form @submit.prevent="setAsTobereturned()">
        <b-form-group>
          <label for="incidence-desc" v-translate>To Be Returned reason</label>
          <b-form-radio-group v-model="tobereturnedDetails" name="tobereturnedDetails" required>
            <b-form-radio :value="{reason: 'max_retries_reached'}" class="w-100"><translate>Maximum retries reached</translate></b-form-radio>
            <b-form-radio v-for="(item, index) in tobereturnedStatusReasons" :value="{reason: item.name, reason_id: item.reason_id}" class="w-100" :key="index">
              {{ item.description }}
            </b-form-radio>
            <b-form-radio :value="{reason: 'other'}" class="w-100"><translate>Other</translate></b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group v-if="tobereturnedDetails.reason === 'other'">
          <label for="incidence-desc" v-translate>To Be Returned Description</label>
          <div class="input-group">
            <b-form-textarea
              id="incidence-desc"
              v-model="newShippingStatusMeta"
              rows="3"
              max-rows="6"
              :state="validateIncidenceDesc"
              required
            />
            <b-form-invalid-feedback :state="validateIncidenceDesc" v-translate>
              "Other" TOBERETURNED status requires a description for the client. Please be brief but descriptive.
            </b-form-invalid-feedback>
            <b-form-valid-feedback :state="validateIncidenceDesc" v-translate>
              Alright.
            </b-form-valid-feedback>
          </div>
        </b-form-group>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Confirm TOBERETURNED</b-button>
          <b-button variant="outline-primary" size="lg" @click.prevent="editingShipping = null; $refs.modalTobereturnedReason.hide()" v-translate>Cancel</b-button>
        </div>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: 'IndicencesInWarehouse',
  data() {
    return {
      shippings: [],
      allShippings: [],
      totalCount: 0,
      filterWarehouse: null,
      filterId: '',
      fields: [
        'id',
        {
          key: 'company_id',
          label: this.$gettext('Company')
        },
        {
          key: 'last_courier',
          label: this.$gettext('Last courier')
        },
        {
          key: 'address_to',
          label: this.$gettext('Address To')
        },
        {
          key: 'last_incidence',
          label: this.$gettext('Last Incidence')
        },
        {
          key: 'incidences_count',
          label: this.$gettext('Incidences Count')
        },
        {
          key: 'warehouse_in_date',
          label: this.$gettext('Warehouse-In Date')
        },
        {
          key: 'need_correction',
          label: this.$gettext('Need Correction')
        },
        {
          key: 'is_corrected',
          label: this.$gettext('Is Corrected')
        },
        {
          key: 'actions',
          label: this.$gettext('Actions')
        }
      ],
      tobereturnedStatusReasons: [],
      editingShipping: null,
      newShippingStatusMeta: '',
      tobereturnedDetails: {},
      statusFilter: 'INCIDENCE',
      timeoutCountdown: null,
      intervalCountdown: null,
      countdown: 60,
      currentPage: 1,
      perPage: 150,
      totalRows: null
    }
  },
  watch: {
    filterWarehouse(val) {
      if (val) {
        this.$cookies.set('warehouse', val)
        this.currentPage = 1
        this.$refs.shippingsTable.refresh()
      } else {
        this.$cookies.remove('warehouse')
        this.clearTimeout()
      }
    },
    statusFilter() {
      this.currentPage = 1
      this.$refs.shippingsTable.refresh()
    },
    filterId(val) {
      this.currentPage = 1
      this.$refs.shippingsTable.refresh()
    }
  },
  mounted() {
    this.fetchWarehouses()
    this.fetchVehicleTypes()
    this.filterWarehouse = this.$cookies.get('warehouse') || null
    this.$http.get(this.$appConfig.api.baseUrl + 'shipping-status-reasons')
      .then(response => {
        this.tobereturnedStatusReasons = response.body.data.filter(x => x.event === 'DELIVERED').map(x => {
          return {name: x.name, description: x.description, reason_id: x.id}
        })
      })
  },
  methods: {
    setTimeout() {
      clearTimeout(this.timeoutCountdown)
      this.timeoutCountdown = setTimeout(() => { this.$refs.shippingsTable.refresh() }, 60000)
    },
    clearTimeout() {
      clearTimeout(this.timeoutCountdown)
      clearInterval(this.intervalCountdown)
      this.countdown = 60
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.countdown = 60
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    fetchIncidencesInWarehouse(ctx) {
      if (this.filterWarehouse) {
        if (this.filterId) {
          if (this.filterId.length >= 8) {
            this.shippings = this.allShippings.filter(x => x.id.indexOf(this.filterId.replace(/\s|\n/g, '')) !== -1)
            this.clearTimeout()
          } else if (this.filterId.length >= 36) {
            this.shippings = this.allShippings.filter(x => x.id === this.filterId.replace(/\s|\n/g, ''))
            this.clearTimeout()
          }
          return this.shippings
        }

        let params = {
          page: ctx.currentPage - 1,
          limit: ctx.perPage,
          includes: [
            'company.settings',
            'status_history.courier',
            'shippingHistory'
          ],
          sort: [
            {
              key: 'updated_at',
              direction: 'desc'
            }
          ],
          filter_groups: [
            {
              filters: [
                ['status', 'eq', this.statusFilter],
                ['courier_id', 'eq', 'null']
              ]
            }
          ]
        }

        if (this.filterWarehouse) {
          params.filter_groups.push(
            {
              filters: [
                ['from_place_id', 'eq', this.filterWarehouse]
              ]
            }
          )
        }

        if (!this.$cookies.get('bypassCountry')) {
          params.filter_groups.push(
            {
              filters: [
                ['from_country_iso_code', 'eq', window.country]
              ]
            }
          )
        }
        return this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
          .then(response => {
            this.shippings = response.body.data.map(x => {
              return this.setIncidenceData(x)
            }).filter(x => x.warehouse_in_date !== null)
            this.allShippings = [...new Set(this.shippings)]
            this.totalCount = this.totalRows = response.body.pagination.total
            if (!this.filterId) {
              this.setTimeout()
              this.setIntervalCountdown()
            } else {
              this.clearTimeout()
            }
            return this.shippings
          })
      } else {
        return []
      }
    },
    setIncidenceData(shipping) {
      if (shipping.company.settings.findIndex(x => x.name === 'max_delivery_incidences') !== -1 && !isNaN(shipping.company.settings.find(x => x.name === 'max_delivery_incidences').pivot.value)) {
        shipping.maxDeliveryIncidencesSetting = parseInt(shipping.company.settings.find(x => x.name === 'max_delivery_incidences').pivot.value)
        shipping.currentDeliveryIncidences = shipping.meta && shipping.meta.delivery_incidences_count ? shipping.meta.delivery_incidences_count : 0
      }
      shipping.ordered_shipping_history = shipping.shipping_history.reverse()
      shipping.last_incidence = shipping.status_history.find(x => x.status === 'INCIDENCE')
      shipping.warehouse_in_date = shipping.ordered_shipping_history.findIndex(x => x.details.courier_id === null) !== -1 ? shipping.ordered_shipping_history.find(x => x.details.courier_id === null).created_at : null
      shipping.need_correction = shipping.last_incidence.details.reason === 'incorrect_address' || null
      const incorrectAddressStatus = shipping.need_correction ? shipping.last_incidence : null
      if (incorrectAddressStatus) {
        const incorrectAddressDate = incorrectAddressStatus.created_at
        const correctedAddressDate = shipping.ordered_shipping_history.findIndex(x => x.details.to_place_id) !== -1 ? shipping.ordered_shipping_history.find(x => x.details.to_place_id).created_at : null
        shipping.is_corrected = correctedAddressDate && incorrectAddressDate && correctedAddressDate.replace(/\D/g, '') > incorrectAddressDate.replace(/\D/g, '') || false
      }
      shipping.last_courier = shipping.status_history.findIndex(x => x.courier) !== -1 ? shipping.status_history.find(x => x.courier).courier : null
      return shipping
    },
    setAsReady(shipping) {
      if (shipping.maxDeliveryIncidencesSetting && shipping.maxDeliveryIncidencesSetting <= shipping.currentDeliveryIncidences) {
        if (confirm(this.$gettextInterpolate(this.$gettext('The shipping has reached the setted Company limit of ***%{maxDeliveryIncidencesSetting}*** for Delivery Incidences and it should be set as TO BE RETURNED. Are you sure you want to SET AS READY the shipping anyway?'), {maxDeliveryIncidencesSetting: shipping.maxDeliveryIncidencesSetting}))) {
          this.doSetAsReady(shipping)
        }
      } else {
        this.doSetAsReady(shipping)
      }
    },
    doSetAsReady(shipping) {
      let params = {
        shipping_id: shipping.id,
        user_id: this.$store.getters.profile.id,
        status: 'READY'
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
        .then(response => {
          this.$refs.shippingsTable.refresh()
        })
    },
    setAsTobereturned() {
      let id = this.editingShipping
      let params = {
        shipping_id: id,
        user_id: this.$store.getters.profile.id,
        status: 'TOBERETURNED',
        meta: this.newShippingStatusMeta || null,
        details: this.tobereturnedDetails
      }

      this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
        .then(response => {
          this.editingShipping = null
          this.newShippingStatusMeta = ''
          this.tobereturnedDetails = {}
          this.$refs.modalTobereturnedReason.hide()
          this.$refs.shippingsTable.refresh()
        })
    },
    filterIncidenceTypes(incidences) {
      return [...new Set(incidences.filter(x => x.status === 'INCIDENCE').map(x => { return x.details.reason }))]
    },
    countIncidenceTypes(incidences, type) {
      return incidences.filter(x => x.status === 'INCIDENCE' && x.details.reason === type).length
    }
  }
}
</script>
